import { Scenario } from 'src/const/state/shop';

// identity账户对应的类型
export const identityTypeMap = {
  UN_SET: 0, // 表示存量 Creative 为 UNSET
  FAKE_USER: 1, // 表示强导流账号类型，即假账号
  AUTH_CODE_USER: 2, // 表示强原生 auth_code 授权账号类型
  TT_USER: 3, // 表示强原生 tt user 授权账号类型
  BC_SELF_TT: 4, // 表示强原生 bc自投tt user 授权账号类型
  BC_AUTH_TT: 5, // 表示强原生 bc代投tt user 授权账号类型
};

/** 原生广告创意对应的 identity账号类型 nativeAdIdentityTypes */
export const NATIVE_AD_IDENTITY_TYPES = [
  identityTypeMap.AUTH_CODE_USER,
  identityTypeMap.TT_USER,
  identityTypeMap.BC_AUTH_TT,
  identityTypeMap.BC_SELF_TT,
];

// identityType 是否属于原生（辅助函数）
export const isNativeAdIdentityType = identityType => NATIVE_AD_IDENTITY_TYPES.includes(identityType);

export const isCustomIdentityAccount = (identityType) => {
  if (Array.isArray(identityType)) {
    return identityType.includes(identityTypeMap.FAKE_USER);
  }

  return identityType === identityTypeMap.FAKE_USER;
};

export const isTTBAIdentityAccount = (identityType) => {
  if (Array.isArray(identityType)) {
    const sameTypeList = _.intersection([identityTypeMap.TT_USER, identityTypeMap.BC_SELF_TT], identityType) || [];
    return !!sameTypeList.length;
  }

  return identityType === identityTypeMap.TT_USER || identityType === identityTypeMap.BC_SELF_TT;
};

export const isTTIdentityAccount = (identityType) => {
  if (Array.isArray(identityType)) {
    const sameTypeList = _.intersection([identityTypeMap.AUTH_CODE_USER, identityTypeMap.BC_AUTH_TT], identityType) || [];
    return !!sameTypeList.length;
  }

  return identityType === identityTypeMap.AUTH_CODE_USER || identityType === identityTypeMap.BC_AUTH_TT;
};


// Identity账户available_status 的枚举值
export const identityAvailableStatus = {
  Available: 0, // 可用状态
  NO_VALID_BIND_ACCOUNT: 1, // 不可用，原因是: 无有效绑定账号
  SCOPE_UNAVAILABLE: 2, // 不可用，原因是:权限不足
  IS_PRIVATE_ACCOUNT: 3, // 不可用，原因是:隐私账号
  NOT_BUSINESS_ACCOUNT: 4, // 不可用，原因是:不是企业号
  NO_DATA: -1, // 前端自定义，接口不返回这个枚举值 表示当前已解绑或者user没有权限
  IS_PRIVATE_POST: -2, // 前端自定义，接口不返回这个枚举值 表示ttba视频设为隐私/下架
  NOT_IDENTITY: -3, // 前端自定义，接口不返回这个枚举值 表示没有identity字段的历史存量数据
  USER_NO_PRIVILEGE: -4, // 前端自定义，接口不返回这个枚举值 表示没有当前登陆的user没有该identity的权限
  NO_LIVE_PREMISSION: -5, //  前端自定义,TTBA账号未获取直播授权
  /** 👇👇 BC账号 👇👇 */
  BC_NO_VALID_BIND_ACCOUNT: 101, // 前端自定义,BC授权账号不是有效可使用账号
  BC_NO_VIDEO_RIGHT: 102, // 前端自定义,BC授权账号没有视频权限
  BC_UN_BIND_ACCOUNT: 103, // 前端自定义,BC授权账号解绑
  BC_NO_LIVE_RIGHT: 104, // 前端自定义，bc授权账号没有live权限
};

// 普通创意广告对应的 identity账号类型
export const normalAdIdentityTypes = [
  identityTypeMap.UN_SET,
  identityTypeMap.FAKE_USER,
];

// 原生广告创意对应的 identity账号类型
export const nativeAdIdentityTypes = [
  identityTypeMap.AUTH_CODE_USER,
  identityTypeMap.BC_SELF_TT,
  identityTypeMap.BC_AUTH_TT,
  identityTypeMap.TT_USER,
];
export const externalTypeAuthMap = { // 不同的externalType对应identity type
  [Scenario.ShortVideo]: [ // 类型的顺序就是identity list返回的顺序
    identityTypeMap.TT_USER,
    identityTypeMap.BC_AUTH_TT,
    identityTypeMap.AUTH_CODE_USER,
  ],
  [Scenario.Live]: [
    identityTypeMap.TT_USER,
    identityTypeMap.BC_AUTH_TT,
  ],
  ALL: [
    identityTypeMap.FAKE_USER,
    identityTypeMap.AUTH_CODE_USER,
    identityTypeMap.TT_USER,
    identityTypeMap.BC_AUTH_TT,
  ],
};

export const bcIdentityTypesList = [identityTypeMap.BC_SELF_TT, identityTypeMap.BC_AUTH_TT];

/** 需要判断权限的identity类型 */
export const JUDGE_IDENTITY_PERMISSION_LIST = [
  identityTypeMap.TT_USER,
  identityTypeMap.BC_AUTH_TT,
  identityTypeMap.BC_SELF_TT,
];

// identity账号类型名称 用于在下拉列表内展示
export const IDENTITY_NAME_MAP = {
  [identityTypeMap.UN_SET]: {
    i18n: 'module_creative_custom_identity', // 可用时的展示名称
    unavailableI18n: 'module_creative_custom_identity', // 不可用时的展示名称
    desc: 'module_creative_identity_custom_identity_account_describe',
    hoverDesc: '',
    icon: '',
    disabledIcon: '',
  },
  [identityTypeMap.FAKE_USER]: {
    i18n: 'module_creative_custom_identity',
    unavailableI18n: 'module_creative_custom_identity',
    desc: 'module_creative_identity_custom_identity_account_describe',
    hoverDesc: '',
    icon: '',
    disabledIcon: '',
  },
  [identityTypeMap.AUTH_CODE_USER]: {
    i18n: 'module_creative_bc_tta_identity_account_describe',
    unavailableI18n: 'module_creative_bc_tta_identity_account_describe',
    desc: 'module_creative_identity_authorized_tiktok_account_describe',
    hoverDesc: '',
    icon: 'vi-icon-tiktok',
    disabledIcon: 'vi-icon-tiktok-disabled',
  },
  [identityTypeMap.TT_USER]: {
    i18n: 'module_creative_tiktok_business_account',
    unavailableI18n: 'module_creative_tiktok_account',
    desc: 'module_creative_identity_select_ttba_account_describe',
    hoverDesc: 'module_creative_identity_account_scope_describe',
    icon: 'vi-icon-tiktok',
    disabledIcon: 'vi-icon-tiktok-disabled',
  },
  [identityTypeMap.BC_AUTH_TT]: {
    i18n: 'module_creative_bc_identity_account_describe', // 位于id下方 标识账号类型
    unavailableI18n: '', // 这个标识 暂时无用
    desc: '', // 这个标识 暂时无用
    hoverDesc: '', // 这个标识 暂时无用
    icon: 'vi-icon-bc',
    disabledIcon: 'vi-icon-bc-disabled',
  },
  [identityTypeMap.BC_SELF_TT]: {
    i18n: '',
    unavailableI18n: '',
    desc: '',
    hoverDesc: '',
    icon: 'vi-icon-bc',
    disabledIcon: 'vi-icon-bc-disabled',
  },
};

const {
  Available,
  NO_VALID_BIND_ACCOUNT,
  SCOPE_UNAVAILABLE,
  IS_PRIVATE_ACCOUNT,
  NOT_BUSINESS_ACCOUNT,
  NO_DATA,
  IS_PRIVATE_POST,
  NOT_IDENTITY,
  USER_NO_PRIVILEGE,
  NO_LIVE_PREMISSION,
  BC_UN_BIND_ACCOUNT,
  BC_NO_VIDEO_RIGHT,
  BC_NO_VALID_BIND_ACCOUNT,
  BC_NO_LIVE_RIGHT,
} = identityAvailableStatus;

// 不可用identity TT USER账号枚举

export const UNAVAILABLE_IDENTITY_ACCOUNT_STATUS_MAP = {
  [Available]: {
    i18n: 'module_creative_identity_unavailable_current_objective', // 不支持当前版位时提示文案
    name: 'module_creative_tiktok_business_account', // 类型名称
    authorizationDesc: '', // 提示按钮文案
    editUnAvailableDesc: '', // 编辑态alert提示
    reAuthorizationDesc: '', // 编辑态提示按钮文案
    hasNoVideoDesc: '', // 缺失post提示文案
  },
  [NO_VALID_BIND_ACCOUNT]: {
    i18n: 'module_creative_scope_unavailable_describe',
    name: 'module_creative_tiktok_business_account',
    authorizationDesc: 'module_creative_get_video_permission',
    bannerAlertDesc: 'module_creative_identity_no_valid_banner_prompt',
    editUnAvailableDesc: 'module_creative_identity_no_valid_prompt',
    reAuthorizationDesc: 'module_creative_identity_regain_permission',
    hasNoVideoDesc: 'module_creative_identity_no_valid_post_prompt',
  },
  [SCOPE_UNAVAILABLE]: {
    i18n: 'module_creative_scope_unavailable_describe',
    name: 'module_creative_tiktok_business_account',
    authorizationDesc: 'module_creative_get_video_permission',
    bannerAlertDesc: 'module_creative_identity_permissions_changed',
    editUnAvailableDesc: 'module_creative_identity_limited_access_banner_prompt',
    reAuthorizationDesc: 'module_creative_identity_regain_permission',
    hasNoVideoDesc: 'module_creative_identity_limited_access_post_prompt',
  },
  [IS_PRIVATE_ACCOUNT]: {
    i18n: 'module_creative_is_private_account_describe',
    name: 'module_creative_tiktok_account',
    authorizationDesc: 'module_creative_upgrade_business_account',
    bannerAlertDesc: 'module_creative_identity_permissions_changed',
    editUnAvailableDesc: 'module_creative_identity_not_ttba_banner_prompt',
    reAuthorizationDesc: 'module_creative_identity_reupgrade',
    hasNoVideoDesc: 'module_creative_identity_not_ttba_post_prompt',
  },
  [NOT_BUSINESS_ACCOUNT]: {
    i18n: 'module_creative_not_business_account',
    name: 'module_creative_tiktok_account',
    authorizationDesc: 'module_creative_upgrade_business_account',
    bannerAlertDesc: 'module_creative_identity_permissions_changed',
    editUnAvailableDesc: 'module_creative_identity_not_ttba_banner_prompt',
    reAuthorizationDesc: 'module_creative_identity_reupgrade',
    hasNoVideoDesc: 'module_creative_identity_not_ttba_post_prompt',
  },
  [NO_DATA]: {
    name: '',
    bannerAlertDesc: 'module_creative_identity_account_not_available',
    editUnAvailableDesc: 'module_creative_identity_select_error_prompt',
    hasNoVideoDesc: 'module_creative_no_identity_info_post_prompt',
  },
  [IS_PRIVATE_POST]: {
    i18n: '',
    name: '',
    authorizationDesc: '',
    bannerAlertDesc: 'module_creative_post_not_available_banner_prompt',
    editUnAvailableDesc: '',
    reAuthorizationDesc: '',
    hasNoVideoDesc: 'module_creative_post_not_available_prompt',
  },
  [NOT_IDENTITY]: {
    name: '',
    bannerAlertDesc: 'module_creative_identity_functional_iteration_prompt',
  },
  // 非当前user
  [USER_NO_PRIVILEGE]: {
    name: '',
    bannerAlertDesc: 'module_creative_identity_not_authorized',
    hasNoVideoDesc: '',
  },
  /** 👇👇 BC账号 👇👇 */
  // BC授权账号没有视频权限
  [BC_NO_VIDEO_RIGHT]: {
    name: 'module_creative_bc_identity_account_describe', // 位于id下方的账号描述文案
    i18n: 'module_creative_bc_identity_need_to_authorize', // 为不可用账号时hover文案
    authorizationDesc: 'module_creative_bc_regain_access', // hover中操作按钮文案
    bannerAlertDesc: 'module_creative_bc_auth_identity_edit_need_authorize_banner', // 可用状态没有这个提示
    editUnAvailableDesc: 'module_creative_bc_auth_identity_edit_need_check_desc', // 编辑状态时位于列表下方的红色不可用提示文案 可用状态没有这个提示
    reAuthorizationDesc: 'module_creative_bc_regain_access', // 可用状态没有这个提示
    hasNoVideoDesc: 'module_creative_bc_auth_identity_edit_need_post_desc', // 可用状态没有这个提示
  },
  // 对应BC账号为不可使用状态 不会出现在下拉框中 只会出现在编辑场景提示
  [BC_NO_VALID_BIND_ACCOUNT]: {
    name: '', // 位于id下方的账号描述文案
    i18n: '', // 为不可用账号状态hover文案
    authorizationDesc: '', // 账号不可用时 hover中操作按钮文案
    bannerAlertDesc: 'module_creative_bc_auth_identity_edit_un_valid_banner', // 位于页面顶部的提示文案
    editUnAvailableDesc: 'module_creative_bc_auth_identity_edit_un_valid_check_desc', // 编辑状态时位于列表下方的红色不可用提示文案
    reAuthorizationDesc: '', // 编辑状态时 引导获取权限的文案
    hasNoVideoDesc: 'module_creative_bc_auth_identity_edit_un_valid_post_desc', // 无素材信息时位于素材选择按钮下方的红色文案
  },
  // 对应BC解绑状态 不会出现在下拉框中 只会出现在编辑场景提示
  [BC_UN_BIND_ACCOUNT]: {
    name: '', // 位于id下方的账号描述文案
    i18n: '', // 为不可用账号状态hover文案
    authorizationDesc: '', // 账号不可用时 hover中操作按钮文案
    bannerAlertDesc: 'module_creative_bc_auth_identity_edit_unbind_banner', // 位于页面顶部的提示文案
    editUnAvailableDesc: 'module_creative_bc_auth_identity_edit_unbind_check_desc', // 编辑状态时位于列表下方的红色不可用提示文案
    reAuthorizationDesc: '', // 编辑状态时 引导获取权限的文案
    hasNoVideoDesc: 'module_creative_bc_auth_identity_edit_unbind_post_desc', // 无素材信息时位于素材选择按钮下方的红色文案
  },
};


/** identity账号不可用的场景 (非TTBA账号没有权限) */
export const UNAVAILABLE_IDENTITY_TYPE_MAP = {
  IsAvalable: 0, // 可用
  IsObjectiveUnsupportNative: 1, // 当前Objective不支持原生广告
  IsObjectiveUnsupportNormal: 2, // 当前Objective不支持导流广告
  IsHasNoTiktok: 4, // 当前版位不包含TT版位 不可用原生类型identity账号
  IsAcoAd: 5, // 当前是程序化创意 不支持原生广告
  IsEditNormalAd: 6, // 编辑导流广告 不可用原生类型identity账号
  IsEditNativeAd: 7, // 编辑原生广告 不可用custom类型identity账号
  IsEditAcoAd: 8, // 编辑程序化创意 不可用原生类型identity账号
};

/** identity账号不可用的场景下的提示文案 */
export const UNAVAILABLE_IDENTITY_PROMPT_MAP = {
  [UNAVAILABLE_IDENTITY_TYPE_MAP.IsAvalable]: '',
  [UNAVAILABLE_IDENTITY_TYPE_MAP.IsObjectiveUnsupportNative]: 'module_creative_identity_unavailable_objective_unsupport',
  [UNAVAILABLE_IDENTITY_TYPE_MAP.IsObjectiveUnsupportNormal]: 'module_creative_identity_unavailable_objective_unsupport_normal',
  [UNAVAILABLE_IDENTITY_TYPE_MAP.IsHasNoTiktok]: 'module_creative_identity_unavailable_on_no_tt_ad',
  [UNAVAILABLE_IDENTITY_TYPE_MAP.IsAcoAd]: 'module_creative_identity_unavailable_on_aco_ad',
  [UNAVAILABLE_IDENTITY_TYPE_MAP.IsEditNormalAd]: 'module_creative_identity_unavailable_on_edit_normal_ad',
  [UNAVAILABLE_IDENTITY_TYPE_MAP.IsEditNativeAd]: 'module_creative_identity_unavailable_on_edit_native_ad',
  [UNAVAILABLE_IDENTITY_TYPE_MAP.IsEditAcoAd]: 'module_creative_identity_unavailable_on_edit_aco_ad',
};

// shop ads的identity位于adgroup且编辑时不允许修改
export const SHOP_ADS_UNAVAILABLE_TTBA_ACCOUNT_TYPE_MAP = {
  [Available]: {
    ...UNAVAILABLE_IDENTITY_ACCOUNT_STATUS_MAP[Available],
    adGroupBannerAlertDesc: '',
  },
  [NO_VALID_BIND_ACCOUNT]: {
    ...UNAVAILABLE_IDENTITY_ACCOUNT_STATUS_MAP[NO_VALID_BIND_ACCOUNT],
    adGroupBannerAlertDesc: 'module_ad_identity_no_enough_permission',
    hasNoVideoDesc: 'module_ad_identity_no_enough_permission_post_prompt',
  },
  [SCOPE_UNAVAILABLE]: {
    ...UNAVAILABLE_IDENTITY_ACCOUNT_STATUS_MAP[SCOPE_UNAVAILABLE],
    adGroupBannerAlertDesc: 'module_ad_identity_no_enough_permission',
    hasNoVideoDesc: 'module_ad_identity_no_enough_permission_post_prompt',
  },
  [IS_PRIVATE_ACCOUNT]: {
    ...UNAVAILABLE_IDENTITY_ACCOUNT_STATUS_MAP[IS_PRIVATE_ACCOUNT],
    adGroupBannerAlertDesc: 'module_ad_identity_no_enough_permission',
    hasNoVideoDesc: 'module_ad_identity_no_enough_permission_post_prompt',
  },
  [NOT_BUSINESS_ACCOUNT]: {
    ...UNAVAILABLE_IDENTITY_ACCOUNT_STATUS_MAP[NOT_BUSINESS_ACCOUNT],
    adGroupBannerAlertDesc: 'module_ad_identity_no_enough_permission',
    hasNoVideoDesc: 'module_ad_identity_no_enough_permission_post_prompt',
  },
  [NO_DATA]: {
    ...UNAVAILABLE_IDENTITY_ACCOUNT_STATUS_MAP[NO_DATA],
    adGroupBannerAlertDesc: 'module_ad_identity_account_not_available',
    editUnAvailableDesc: 'module_ad_identity_select_error_prompt',
  },
  [IS_PRIVATE_POST]: {
    ...UNAVAILABLE_IDENTITY_ACCOUNT_STATUS_MAP[IS_PRIVATE_POST],
  },
  [NOT_IDENTITY]: {
    ...UNAVAILABLE_IDENTITY_ACCOUNT_STATUS_MAP[NOT_IDENTITY],
  },
  [USER_NO_PRIVILEGE]: {
    adGroupBannerAlertDesc: 'module_ad_identity_not_authorized',
    editUnAvailableDesc: 'module_ad_identity_not_authorized_prompt',
    bannerAlertDesc: 'module_creative_identity_not_authorized',
  },
  [NO_LIVE_PREMISSION]: {
    ...UNAVAILABLE_IDENTITY_ACCOUNT_STATUS_MAP[SCOPE_UNAVAILABLE],
    i18n: 'module_creative_live_scope_unavailable_describe',
    adGroupBannerAlertDesc: 'module_ad_identity_no_enough_permission',
  },
  [BC_NO_VALID_BIND_ACCOUNT]: {
    name: '', // 位于id下方的账号描述文案
    i18n: '', // 为不可用账号状态hover文案
    authorizationDesc: '', // 账号不可用时 hover中操作按钮文案
    bannerAlertDesc: 'module_creative_bc_auth_identity_edit_un_valid_banner', // 位于页面顶部的提示文案
    editUnAvailableDesc: 'module_creative_bc_auth_identity_edit_un_valid_check_desc', // 编辑状态时位于列表下方的红色不可用提示文案
    reAuthorizationDesc: '', // 编辑状态时 引导获取权限的文案
    hasNoVideoDesc: 'module_creative_bc_auth_identity_edit_un_valid_post_desc', // 无素材信息时位于素材选择按钮下方的红色文案
    adGroupBannerAlertDesc: 'module_creative_bc_auth_identity_edit_un_valid_banner',
  },
  [BC_UN_BIND_ACCOUNT]: {
    name: 'module_creative_bc_identity_account_unavailable_describe', // 位于id下方的账号描述文案
    i18n: 'module_creative_bc_identity_no_valid_bind_account', // 为不可用账号状态hover文案
    authorizationDesc: 'module_creative_bc_regain_valid', // 账号不可用时 hover中操作按钮文案
    adGroupBannerAlertDesc: 'module_creative_bc_auth_identity_edit_unbind_banner',
    bannerAlertDesc: 'module_creative_bc_auth_identity_edit_unbind_banner', // 位于页面顶部的提示文案
    editUnAvailableDesc: 'module_creative_bc_auth_identity_edit_unbind_check_desc', // 编辑状态时位于列表下方的红色不可用提示文案
    reAuthorizationDesc: '', // 编辑状态时 引导获取权限的文案
    hasNoVideoDesc: 'module_creative_bc_auth_identity_edit_unbind_post_desc', // 无素材信息时位于素材选择按钮下方的红色文案
  },
  [BC_NO_VIDEO_RIGHT]: {
    name: 'module_creative_bc_identity_account_describe', // 位于id下方的账号描述文案
    i18n: 'module_creative_bc_identity_need_to_authorize', // 为不可用账号时hover文案
    authorizationDesc: 'module_creative_bc_regain_access', // hover中操作按钮文案
    adGroupBannerAlertDesc: 'module_creative_bc_auth_identity_edit_need_authorize_banner',
    bannerAlertDesc: 'module_creative_bc_auth_identity_edit_need_authorize_banner', // 可用状态没有这个提示
    editUnAvailableDesc: 'module_creative_bc_auth_identity_edit_need_check_desc', // 编辑状态时位于列表下方的红色不可用提示文案 可用状态没有这个提示
    reAuthorizationDesc: 'module_creative_bc_regain_access', // 可用状态没有这个提示
    hasNoVideoDesc: 'module_creative_bc_auth_identity_edit_need_post_desc', // 可用状态没有这个提示
  },
  [BC_NO_LIVE_RIGHT]: {
    name: 'module_creative_bc_identity_account_describe', // 位于id下方的账号描述文案
    i18n: 'module_creative_bc_identity_need_to_authorize', // 为不可用账号时hover文案
    authorizationDesc: 'module_creative_bc_regain_access', // hover中操作按钮文案
    adGroupBannerAlertDesc: 'module_creative_bc_auth_identity_edit_need_authorize_banner',
    bannerAlertDesc: 'module_creative_bc_auth_identity_edit_need_authorize_banner', // 可用状态没有这个提示
    editUnAvailableDesc: 'module_creative_bc_auth_identity_edit_need_check_desc', // 编辑状态时位于列表下方的红色不可用提示文案 可用状态没有这个提示
    reAuthorizationDesc: 'module_creative_bc_regain_access', // 可用状态没有这个提示
    hasNoVideoDesc: 'module_creative_bc_auth_identity_edit_need_post_desc', // 可用状态没有这个提示
  },
};

// 新identity禁用switch文案
export const IDENTITY_OP_SWITCH_DISABLED_KEY_MAP = {
  NOT_CONTAIN_TT_REASON: 1,
  DISABLED_ACO_REASON: 2,
  DISABLED_OBJECTIVE_NOT_NATIVE_REASON: 3,
  DISABLED_OBJECTIVE_NOT_NORMAL_REASON: 4,
  DISABLED_IS_FIRST_CREATE_CUSTOM_REASON: 5,
  DISABLED_NORMAL_TO_NATIVE_REASON: 6,
  DISABLED_NATIVE_TO_NORMAL_REASON: 7,
};

export const IDENTITY_OP_SWITCH_DISABLED_MAP = {
  [IDENTITY_OP_SWITCH_DISABLED_KEY_MAP
    .NOT_CONTAIN_TT_REASON]: 'module_identity_switch_disabled_not_contain_tt_reason', // 当前您选择的版位中未包含TikTok，因此暂时无法投放原生广告
  [IDENTITY_OP_SWITCH_DISABLED_KEY_MAP
    .DISABLED_ACO_REASON]: 'module_identity_switch_disabled_aco_reason', // 程序化创意暂时不支持投放原生广告
  [IDENTITY_OP_SWITCH_DISABLED_KEY_MAP
    .DISABLED_OBJECTIVE_NOT_NATIVE_REASON]: 'module_identity_switch_disabled_objective_not_native_reason', // 当前您的推广目标暂时不支持投放原生广告
  [IDENTITY_OP_SWITCH_DISABLED_KEY_MAP
    .DISABLED_OBJECTIVE_NOT_NORMAL_REASON]: 'module_identity_switch_disabled_objective_not_normal_reason', // 当前推广目标不支持投放导流广告
  [IDENTITY_OP_SWITCH_DISABLED_KEY_MAP
    .DISABLED_IS_FIRST_CREATE_CUSTOM_REASON]: 'module_identity_switch_disabled_is_first_create_custom_reason', // 不存在custom账号（需要首次创建）
  [IDENTITY_OP_SWITCH_DISABLED_KEY_MAP
    .DISABLED_NORMAL_TO_NATIVE_REASON]: 'module_identity_switch_disabled_normal_to_native_reason', // 暂时不支持导流广告和原生广告进行切换
  [IDENTITY_OP_SWITCH_DISABLED_KEY_MAP
    .DISABLED_NATIVE_TO_NORMAL_REASON]: 'module_identity_switch_disabled_native_to_normal_reason', // 暂时不支持原生广告和导流广告进行切换
};

export const IDENTITY_FEEL_GOOD_MAP = {
  [identityTypeMap.FAKE_USER]: 'useCustomIdentity',
  [identityTypeMap.AUTH_CODE_USER]: 'useTtaIdentity',
  [identityTypeMap.TT_USER]: 'useTtbaIdentity',
};


export const IDENTITY_VALIDATION_ERROR_TEXT = {
  [NO_DATA]: 'module_creative_identity_select_error_prompt',
  [BC_UN_BIND_ACCOUNT]: 'module_creative_bc_auth_identity_edit_unbind_check_desc',
  SHOP: 'module_creative_identity_select_validate_info',
};
